import React from "react";
import { assetUrl } from "../../config";
import WebP from "../global/WebP";
import ArrowRight from "../../../assets/svg/arrowRight.svg";
import ScreenshotsComponent from "./Screenshots";
import { mobile } from "../../utilities/detection";
import { parseFileSecret } from "../../utilities";

export default function GameScreenshots({ game, clickHandler }) {
  const renderScreenShots = () => {
    if (game?.id) {
      let orientation = mobile && game.mobileOrientation ? game.mobileOrientation : game.orientation;

      if (["vertical", "portrait"].includes(orientation)) {
        orientation = "vertical";
      } else {
        orientation = "horizontal";
      }

      let fileSecret;

      if (game.screenshots?.length > 0) {
        const shouldDiffer = game.mobileOrientation && game.mobileOrientation !== game.orientation;

        fileSecret = game.screenshots[0];

        if (shouldDiffer) {
          const key = "_desktop";
          const secret = game.screenshots.find((s) => !s.includes(key));
          const desktopSecret = game.screenshots.find((s) => s.includes(key));

          fileSecret = !mobile ? desktopSecret : secret;
        }

        if (fileSecret) {
          const parsedSecret = parseFileSecret(fileSecret);

          if (parsedSecret.size) {
            fileSecret = parsedSecret;
          } else {
            return (
              <WebP
                secret={`${assetUrl}${fileSecret}`}
                imgProps={{ alt: game.fullname, fetchPriority: "high" }}
                key={fileSecret}
              />
            );
          }
        }
      }

      return <ScreenshotsComponent fullname={game.fullname} orientation={orientation} fileSecret={fileSecret} />;
    }

    return null;
  };

  return (
    <div onClick={clickHandler} tabIndex={1} className="game-screenshots" data-testid="game-screenshots">
      {renderScreenShots()}
      <button type="button" className="playbutton button-flat-color orange dimensional">
        <ArrowRight />
      </button>
    </div>
  );
}
